<script>
import {skills} from "../resume-store";

</script>
<!--------------------------------------------------------------------------------------------------------------------->

<div class="skills">
    {#each $skills as skill (skill.type)}
        <div class="type">
            <h4>{skill.type}</h4>
            <ul>
                {#each skill.skillList as elem}
                    <li>{elem}</li>
                {/each}
            </ul>
        </div>
    {/each}
</div>

<!--------------------------------------------------------------------------------------------------------------------->
<style>
    .skills {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        flex-grow: 1;
    }

    .type {
        padding-bottom: 2rem;
    }

    ul {
        padding-left: 1px;
    }

    @media screen and (max-width: 500px) {
        .skills {
            flex-direction: column;
        }
        .type {
            min-height: unset;
        }
        ul {
            list-style-type: circle;
            margin-left: 20px;
        }
    }
    @media screen and (min-width: 501px) and (max-width: 1000px) {
        .type {
            padding-bottom: 2rem;
        }
    }
</style>